import { render, staticRenderFns } from "./CreateFollowup.vue?vue&type=template&id=5ddc04a2&scoped=true"
import script from "./CreateFollowup.vue?vue&type=script&lang=js"
export * from "./CreateFollowup.vue?vue&type=script&lang=js"
import style0 from "./CreateFollowup.vue?vue&type=style&index=0&id=5ddc04a2&prod&lang=scss&scoped=true"
import style1 from "./CreateFollowup.vue?vue&type=style&index=1&id=5ddc04a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc04a2",
  null
  
)

export default component.exports